module.exports = __webpack_public_path__ + "img/ilsas-logo-navbar.9612ee04.png";